import { render, staticRenderFns } from "./ptf-list.vue?vue&type=template&id=73a7df24&scoped=true"
import script from "./ptf-list.vue?vue&type=script&lang=js"
export * from "./ptf-list.vue?vue&type=script&lang=js"
import style0 from "./ptf-list.vue?vue&type=style&index=0&id=73a7df24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7df24",
  null
  
)

export default component.exports